/* eslint-disable semi */
const debug = process.env.NODE_ENV === 'development';

/**
 * デコレータ設定管理
 */
class DecoratorConfigsClass {
  constructor () {
    this.configs = {};
  }
  set (name, config) {
    if (debug) {
      if (name in this.configs) {
        console.warn(`Configurations: ${name} is duplicated.`);
      }
    }
    this.configs[name] = config;
  }
  setConfigs (configs) {
    Object.keys(configs).forEach(name => {
      this.set(name, configs[name]);
    });
  }
  marge (name, options = {}) {
    let marged = {};
    if (name in this.configs) {
      marged = Object.assign(marged, this.configs[name]);
    }
    marged = Object.assign(marged, options);
    return marged;
  }
}
export default new DecoratorConfigsClass();



// WEBPACK FOOTER //
// ./src/core/decorators/DecoratorConfigs.js